module.exports = __webpack_public_path__ + "img/sketch.3b8c5760.jpg";